export const SET_DIALPLANS = "SET_DIALPLANS";
export const ADD_DIALPLANS_TO_LIST = "ADD_DIALPLANS_TO_LIST";
export const UPDATE_DIALPLAN = "UPDATE_DIALPLAN";
export const SET_DIALPLANRULES = "SET_DIALPLANRULES";
export const ADD_DIALPLANRULES = "ADD_DIALPLANRULES";
export const UPDATE_DIALPLANRULES = "UPDATE_DIALPLANRULES";
export const REMOVE_DIALPLANRULES = "REMOVE_DIALPLANRULES";
export const SET_PRICES_TRUNKS_DIALPLAN = "SET_PRICES_TRUNKS_DIALPLAN";
export const REMOVE_DIALPLAN = "REMOVE_DIALPLAN";
